export const appID = 'a50955429d255a58';

export const shareInfoItems = [
  {
    label: 'Change',
    yourIR: 'change',
  },
  {
    label: 'Prev close',
    yourIR: 'prevClose',
  },
  {
    label: 'Low',
    yourIR: 'low',
  },
  {
    label: 'High',
    yourIR: 'high',
  },
  {
    label: 'Open',
    yourIR: 'open',
  },
  {
    label: 'Volume',
    yourIR: 'volume scale=false',
  },
];
